import React, { useState } from 'react';
import CarServices from '../../services/CarServices';

const ToggleShowHide = ({ data, onSuccess }) => {
  const [isChecked, setIsChecked] = useState(data?.menu_status === "show");

  const handleToggle = async () => {
    const isNowShow = !isChecked;
    setIsChecked(isNowShow);
    await CarServices.updateService(data._id, {
      menu_status: isNowShow ? "show" : "hide"
    });

    onSuccess();
  };

  return (
    <div className="check-box">
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleToggle}
      />
    </div>
  );
};

export default ToggleShowHide;